<div>
    <div class="expension-header-wrapper" (click)="onExpensionChange()" [class.disabled]="disable">
      <div class="expension-header-content">
        <div>
          {{ titleText }}
        </div>
  
        <div>
          <mat-icon  *ngIf="!panelOpenState">keyboard_arrow_down</mat-icon>
          <mat-icon *ngIf="panelOpenState">keyboard_arrow_up</mat-icon>
        </div>
      </div>
    </div>
    <ng-content *ngIf="panelOpenState"></ng-content>
  </div>
  